import Loading from '../components/Loading';
import React from 'react';
import SignIn from '../components/SignIn';
import SignedIn from '../components/SignedIn';
import authService from '../services/auth';
import signIn from '../actions/signIn';
import { IProfileResponse } from '../model/ProfileResponse';
import queryString from '../services/queryString';
import routing from '../services/routing';

export const context = 'signIn';

interface ISignInRouteState {
    error?: string;
    isLoading: boolean;
    username?: string;
}

export class SignInRoute extends React.Component<any, ISignInRouteState> {
    state = {
        error: undefined,
        isLoading: true,
        username: undefined,
    };

    async componentDidMount() {
        try {
            const res: IProfileResponse = await authService.getUserInfo();
            const { data } = res;
            const params = queryString.parse(routing.location.search);

            if (params && params.redirect_uri) {
                routing.location.href = params.redirect_uri;
            } else {
                this.setState({
                    isLoading: false,
                    username: data && data.email ? data.email : undefined,
                });
            }
        } catch (error) {
            if (error.message === 'USER_NOT_LOGGED_IN') {
                this.setState({
                    isLoading: false,
                });
            } else {
                this.setState({ error: error.message });
            }
        }
    }

    render() {
        const { error, isLoading, username } = this.state;
        if (error) {
            throw error;
        }

        if (isLoading) {
            return <Loading />;
        }

        if (username !== undefined) {
            // @ts-ignore
            return <SignedIn username={username} />;
        }

        return <SignIn context={context} action={signIn} />;
    }
}

export default SignInRoute;
